// ======================================================================
// File Name       : ServiceDetailForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { USER_TYPE } from '../../constants/KeyValueConstants';
import * as ServiceConstant from '../../constants/ServiceConstant';
import { DEFAULT_DATE_FORMAT, HYPHEN, LO_SUPER_USER, USAGE_SETTING } from '../../constants/index';
import * as utils from '../../utils';
import { getEnterprisePath } from '../../utils/EnterPriseUtils';
import { copyTextToClipboard, getDocumentDownloadPermissionLabel, getDocumentPrintingPermissionLabel, getServiceCategoryStatus, getServiceDeleteFlagLabel } from '../../utils/ServiceUtils';
import { getItemBoxName, getSettingUsageLabel, parseDateForDetail } from '../../utils/index';

const ServiceDetail = ({ service, enterpriseList, displayUserType,
  isUsedVideoSpeedSetting, videoSpeedSettingConfirmation, videoMcJobtemplateComfirm, isConfirm, isNewMode, xmlUploadFileName, rootFlag }) => {
  const { videoMcJobtemplate, videoSpeedSetting, usageSettingSaml, certificateUsageFlag } = service.usageSettingInfo;
  const isVideoSpeedSetting = isConfirm ? isUsedVideoSpeedSetting : (!!videoSpeedSetting);
  const videoSpeedSettingContent = isConfirm ? videoSpeedSettingConfirmation.join(HYPHEN) : videoSpeedSetting;
  let videoSpeedSetingText = '';
  if (isVideoSpeedSetting && videoSpeedSettingContent.length > 0) {
    videoSpeedSettingContent.split(HYPHEN).sort().map((value) => {
      videoSpeedSetingText += `${value}倍/`;
    });
  } else {
    videoSpeedSetingText = '1.0倍のみ';
  }

  const usageSettingCertificate = certificateUsageFlag ? USAGE_SETTING.USE : USAGE_SETTING.UN_USE;
  // #7494 START
  const isContentDistributionService = parseInt(service.serviceType, 10) === 2;
  // #7494 END
  // STEP7.0 #3 START
  const isSupperUserL0 = [LO_SUPER_USER].indexOf(displayUserType) > -1;
  // STEP7.0 #3 END

  return service &&
    <div>
      <Col className="padding-left-15 padding-right-15">
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">企業名</Col>
            <Col sm={9} className="form-label">
              {getEnterprisePath(service.enterpriseInfo, enterpriseList)}
            </Col>
          </Form.Group>
          {service.institutionId
            ? <Form.Group className="form-info">
              <Col sm={3} className="form-label">サービスID</Col>
              <Col sm={9} className="form-label">
                {service.institutionId}
              </Col>
            </Form.Group>
            : null}
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">サービス種別</Col>
            <Col sm={9} className="form-label">
              {getItemBoxName(ServiceConstant.ServiceType, service.serviceType)}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">サービス名</Col>
            <Col sm={9} className="form-label">{service.serviceName}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">サービスコード</Col>
            <Col sm={9} className="form-label">{service.serviceCd}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">サービス利用ユーザー{isConfirm && (<br />)}サイトドメイン</Col>
            <Col sm={9} className="form-label">{`ss-${service.domainName ? service.domainName : service.serviceCd.replace(/_/g, HYPHEN)}.l-cloud.jp`}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">パスワード強度</Col>
            <Col sm={9} className="form-label">
              {getItemBoxName(ServiceConstant.PasswordStrength, service.passwordStrength)}
            </Col>
          </Form.Group>
          {/* // Step SAML START */}
          {!isNewMode && !isContentDistributionService && <>
            <Form.Group className="form-info">
              <Col sm={3} className="form-label pe-0">クライアント証明書認証</Col>
              <Col sm={9} className="form-label">
                {getSettingUsageLabel(usageSettingCertificate)}
              </Col>
            </Form.Group>
          </>
          }
          {/* // Step SAML END */}
          {/* Step10.0.0 START */}
          {!isNewMode && !isContentDistributionService && (
            <Form.Group className="form-info" controlId="mfaUsageFlag">
              <Col sm={3} className="form-label">MFA認証</Col>
              <Col className="form-label" sm={7}>
                {utils.getSettingUsageBooleanLabel(service.mfaUsageFlag)}
              </Col>
            </Form.Group>
          )}
          {/* Step10.0.0 END */}
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">備考</Col>
            <Col sm={9} className="form-label">{service.remark}</Col>
          </Form.Group>

          {/* sprint_20230403 #4 START */}
          {/* 
            * L0 user: 利用開始日 can show on detail/edit/confirm screen
            * L1 user: 利用開始日 can show on detail screen only
          */}
          {!isNewMode && !isContentDistributionService && (isSupperUserL0 || (!isSupperUserL0 && !isConfirm)) && (
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">利用開始日</Col>
              <Col sm={9} className="form-label">{utils.parseDateForDetail(service.serviceStartDate, DEFAULT_DATE_FORMAT)}</Col>
            </Form.Group>
          )}
          {/* sprint_20230403 #4 END */}

          <hr className='break-line'/>
          <Form.Group className="form-info">
            <Col className="form-label" sm={12}>利用機能設定</Col>
          </Form.Group>
              <Form.Group className="form-info padding-left-50 padding-top-10">
                <Col className="form-label" sm={3} >ビデオ</Col>
                <Col className="form-label" sm={7}>
                  {getItemBoxName(
                    ServiceConstant.AvailableDisableUsage,
                    service.usageSettingInfo.usageSettingVideo,
                  )}
                </Col>
              </Form.Group>
              {/* Display only for super user L0 */}
              {displayUserType === USER_TYPE.ADMIN && (
                <>
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col className="form-label" sm={3} >
                    ジョブテンプレート名
                    </Col>
                    <Col className="form-label" sm={7}>
                      {isConfirm ? videoMcJobtemplateComfirm : videoMcJobtemplate}
                    </Col>
                  </Form.Group>
                </>
              )}
              {/* sprint_20230403 #5 START */}
              <Form.Group className="form-info padding-left-50 padding-top-10">
                <Col sm={3} className="form-label">
                  再生速度一覧
                </Col>
                <Col sm={7} className="form-label">
                  {isVideoSpeedSetting ? videoSpeedSetingText.slice(0, -1) : videoSpeedSetingText}
                </Col>
              </Form.Group>
              {/* sprint_20230403 #5 END */}
              {/* // STEP7.0 #3 START */}
              { isSupperUserL0 && (
                <Form.Group className="form-info padding-left-50 padding-top-10">
                <Col sm={11} className="form-label">
                  <Form.Check
                    type='checkbox'
                    className="cursor-default"
                    name="usageSettingSufCustomize"
                    id="usageSettingSufCustomizeDetail"
                    disabled
                    checked={service.usageSettingInfo.usageSettingSufCustomize}
                    label='サービス利用ユーザー画面をカスタマイズする'></Form.Check>
                </Col>
              </Form.Group>
              )}
              {/* // STEP7.0 #3 END */}
              
            {/* sprint_20230403 #4 START */}
            {/* 
              * L0: show on edit/confirm/detail
              * L1: show on detail only 
             */}
            {!isNewMode && !isContentDistributionService && (isSupperUserL0 || (!isSupperUserL0 && !isConfirm)) ? (
              <>
                {isSupperUserL0 && (
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">管理者UIカスタマイズ</Col>
                    <Col sm={8} className="form-label">{utils.getSettingUsageBooleanLabel(service.adminUiCustomize)}</Col>
                  </Form.Group>
                )}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">IPアドレス制限利用</Col>
                  <Col sm={8} className="form-label">{utils.getSettingUsageBooleanLabel(service.ipRestriction)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ドキュメント印刷許可</Col>
                  <Col sm={8} className="form-label">{getDocumentPrintingPermissionLabel(service.documentPrintingPermission)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ドキュメントダウンロード許可</Col>
                  <Col sm={8} className="form-label">{getDocumentDownloadPermissionLabel(service.documentDownloadPermission)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">個人設定編集表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.personalSettingsEditDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">進捗状況表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.progressStatusDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">学習履歴表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.learningHistoryDisplay)}</Col>
                </Form.Group>
                {/* Step 10.0.0 START */}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ヘルプ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.helpDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">お知らせ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.noticeDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">メッセージ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.messageDisplay)}</Col>
                </Form.Group>
                {/* Step 10.0.0 END */}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">パスワードリセットメッセージ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.passwordResetMessageDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ビデオ先送り禁止</Col>
                  {/* Step9.0.1 START */}  
                  <Col sm={8} className="form-label">{utils.getSettingUsageBooleanLabel(service.videoForwardingProhibited)}</Col>
                  {/* Step9.0.1 END */}  
                </Form.Group>
                {/* Step 12.0.0 Sprint44 START */}
                {(isSupperUserL0 || rootFlag) && (
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">バックグラウンド再生フラグ</Col>
                    <Col sm={8} className="form-label">{utils.getBackgroundVideoPlaybackFlagLabel(service.backgroundVideoPlaybackFlag)}</Col>
                  </Form.Group>
                )}
                {/* Step 12.0.0 Sprint44 END */}  
                {/* Step8.0.3 START */}
                {isSupperUserL0 && (
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">プライバシーポリシー表示</Col>
                    <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.privacyPolicyDisplay)}</Col>
                  </Form.Group>
                )}
                {/* Step8.0.3 END */}
                {isSupperUserL0 && (
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">カスタマイズ範囲</Col>
                    <Col sm={8} className="form-label">{service.customizeRange}</Col>
                  </Form.Group>
                )}
                {/* sprint_20230508 #27 START */}
                {/* Step 9.3.0 START */}
                {isSupperUserL0 && (
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">休止ユーザーデータ取得許可</Col>
                    <Col sm={8} className="form-label">{utils.getDormantUserDataAcquisitionPermissionFlag(service.dormantUserDataAcquisitionPermissionFlag)}</Col>
                  </Form.Group>
                )}
                {/* Step 9.3.0 END */}
                {/* sprint_20230508 #27 END */}
                {/* STEP13.0.0 TAS-21617 START */}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ビデオ完了しきい値</Col>
                  {service.videoEndThreshold !== "" && !isNaN(service.videoEndThreshold) && (
                    <Col sm={8} className="form-label">{`${service.videoEndThreshold}%`}</Col>
                  )}
                </Form.Group>
                {/* STEP13.0.0 TAS-21617 END */}
              </>
              ) : !isSupperUserL0 && isConfirm && rootFlag && (
              <>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ドキュメント印刷許可</Col>
                  <Col sm={8} className="form-label">{getDocumentPrintingPermissionLabel(service.documentPrintingPermission)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ドキュメントダウンロード許可</Col>
                  <Col sm={8} className="form-label">{getDocumentDownloadPermissionLabel(service.documentDownloadPermission)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">個人設定編集表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.personalSettingsEditDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">進捗状況表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.progressStatusDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">学習履歴表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.learningHistoryDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">メッセージ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.messageDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">パスワードリセットメッセージ表示</Col>
                  <Col sm={8} className="form-label">{utils.getStatusDisplayLabel(service.passwordResetMessageDisplay)}</Col>
                </Form.Group>
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ビデオ先送り禁止</Col>
                  <Col sm={8} className="form-label">{utils.getSettingUsageBooleanLabel(service.videoForwardingProhibited)}</Col>
                </Form.Group>
                {/* STEP13.0.0 TAS-23260 START */}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col sm={3} className="form-label">バックグラウンド再生フラグ</Col>
                    <Col sm={8} className="form-label">{utils.getBackgroundVideoPlaybackFlagLabel(service.backgroundVideoPlaybackFlag)}</Col>
                  </Form.Group>
                {/* STEP13.0.0 TAS-23260 END */}
                <Form.Group className="form-info padding-left-50 padding-top-10">
                  <Col sm={3} className="form-label">ビデオ完了しきい値</Col>
                  {service.videoEndThreshold !== "" && !isNaN(service.videoEndThreshold) && (
                    <Col sm={8} className="form-label">{`${service.videoEndThreshold}%`}</Col>
                  )}
                </Form.Group>
              </>
            )}
            {/* STEP13.0.0 TAS-21617 END */}
            {/* sprint_20230403 #4 END */}
              {/* // Step SAML START */}
              {
                !isNewMode && !isContentDistributionService && <>
                  <Form.Group className="form-info padding-left-50 padding-top-10">
                    <Col className="form-label" sm={3} >シングルサインオン{isConfirm && (<br />)}設定</Col>
                    <Col className="form-label" sm={7}>
                      {getSettingUsageLabel(parseInt(usageSettingSaml, 10))}
                    </Col>
                  {parseInt(usageSettingSaml, 10) === USAGE_SETTING.USE && (
                    <>
                      <Col sm={12} className="form-label">
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="padding-left-right-clear">
                            IdP側設定内容
                          </Col>
                        </Col>
                        {/* // #7498 START */}
                        {xmlUploadFileName && (
                          <Col sm={12} className="form-label">
                            <Col sm={3} className="form-label">
                              メタデータXML
                            </Col>
                            <Col sm={9} className="form-label padding-left-clear">
                              {xmlUploadFileName}
                            </Col>
                          </Col>
                        )}
                        {/* // #7498 END */}
                        {/* // #7512 START */}
                        {(!isConfirm || (isConfirm && !xmlUploadFileName)) && <>
                          <Col sm={12} className="form-label">
                            <Col sm={3} className="form-label">
                              ログインURL
                            </Col>
                            <Col sm={9} className="form-label padding-left-clear">
                              {service.usageSettingInfo.idpLoginUrl}
                            </Col>
                          </Col>
                          <Col sm={12} className="form-label">
                            <Col sm={3} className="form-label">
                              ログアウトURL
                            </Col>
                            <Col sm={9} className="form-label padding-left-clear">
                              {service.usageSettingInfo.idpLogoutUrl}
                            </Col>
                          </Col>
                          <Col sm={12} className="form-label">
                            <Col sm={3} className="form-label">
                              エンティティID<br />(IdP識別子)
                            </Col>
                            <Col sm={9} className="form-label padding-left-clear">
                              {service.usageSettingInfo.idpEntityId}
                            </Col>
                          </Col>
                          <Col sm={12} className="form-label">
                            <Col sm={3} className="form-label">
                              証明書有効期限
                            </Col>
                            <Col sm={9} className="form-label padding-left-clear">
                              {parseDateForDetail(service.usageSettingInfo.idpCertificateExpiredDate)}
                            </Col>
                          </Col>
                        </>}
                        {/* // #7512 END */}
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="padding-left-right-clear">
                            SP設定用情報
                          </Col>
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            エンティティID
                          </Col>
                          <Col sm={8} className="form-label padding-left-clear">
                            {service.usageSettingInfo.spEntityId}
                          </Col>
                          {service.usageSettingInfo.spEntityId && (
                            <Col sm={1} className="form-label">
                              <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(service.usageSettingInfo.spEntityId)} />
                            </Col>
                          )}
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            応答URL
                          </Col>
                          <Col sm={8} className="form-label padding-left-clear">
                            {service.usageSettingInfo.spReplyUrl}
                          </Col>
                          {service.usageSettingInfo.spReplyUrl && (
                            <Col sm={1} className="form-label">
                              <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(service.usageSettingInfo.spReplyUrl)} />
                            </Col>
                          )}
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            ログアウトURL
                          </Col>
                          <Col sm={8} className="form-label padding-left-clear">
                            {service.usageSettingInfo.spSloUrl}
                          </Col>
                          {service.usageSettingInfo.spSloUrl && (
                            <Col sm={1} className="form-label">
                              <i className="bi bi-clipboard-fill cursor_pointer" onClick={() => copyTextToClipboard(service.usageSettingInfo.spSloUrl)} />
                            </Col>
                          )}
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="padding-left-right-clear">
                            サービス設定用情報
                          </Col>
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            ログイン画面URL
                          </Col>
                          <Col sm={9} className="form-label padding-left-clear">
                            {service.usageSettingInfo.loginSuccessRedirectUrl}
                          </Col>
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            ログアウト画面URL
                          </Col>
                          <Col sm={9} className="form-label padding-left-clear">
                            {service.usageSettingInfo.logoutSuccessRedirectUrl}
                          </Col>
                        </Col>
                        <Col sm={12} className="form-label">
                          <Col sm={3} className="form-label">
                            エラー画面URL
                          </Col>
                          <Col sm={9} className="form-label padding-left-clear">
                            {service.usageSettingInfo.errorRedirectUrl}
                          </Col>
                        </Col>
                      </Col>
                    </>
                  )
                  }
                  </Form.Group>
                </>
              }
          {/* // Step SAML END */}
          <hr className='break-line'/>
          <Form.Group className="form-info" controlId="dormantState">
            <Col sm={3} className="form-label">稼働状態</Col>
            <Col className="form-label" sm={7}>
              {getItemBoxName(
                ServiceConstant.DormantState,
                service.dormantState,
              )}
            </Col>
          </Form.Group>

          {/* sprint_20230403 #4 START */}
          {isSupperUserL0 && !isNewMode && !isContentDistributionService && (
            <>
              <Form.Group className="form-info">
                <Col sm={3} className="form-label">サービス区分</Col>
                <Col sm={7} className="form-label">{getServiceCategoryStatus(service.serviceCategory)}</Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} className="form-label">解約フラグ</Col>
                <Col sm={7} className="form-label">{getServiceDeleteFlagLabel(service.serviceDeleteFlag)}</Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} className="form-label">解約予定日</Col>
                <Col sm={7} className="form-label">{utils.parseDateForDetail(service.serviceDeleteDate, DEFAULT_DATE_FORMAT)}</Col>
              </Form.Group>
            </>
          )}
          {/* sprint_20230403 #4 END */}
          {/* sprint_20230418 #13 START */}
          {!isNewMode && !isContentDistributionService && !isConfirm && (
            <>
              <Form.Group className="form-info">
                <Col sm={3} className="form-label">契約企業コード</Col>
                <Col sm={7} className="form-label">{service.contractEnterpriseCd}</Col>
              </Form.Group>
            </>
          )}
          {/* sprint_20230418 #13 END */}
        </Form>
      </Col>
    </div>;
}

export default ServiceDetail;
